import React from 'react';
import PropTypes from 'prop-types';

const MetricCard = ({ title, children }) => {
    return (
        <div className="metric-card">
            <h4>{title}</h4>
            {children}
        </div>
    );
};

MetricCard.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};

export default MetricCard;
